/**
 * Post-draft legion rosters for the Coming Soon team cards.
 * Order is the published draft order. Pick 01 is the captain.
 */
/** Circular headshots for the captain card, matched to each legion. */
export const CAPTAIN_HEADSHOTS: Record<string, string> = {
  tixinha: "/assets/roster/captains/tixinha.png",
  baggins: "/assets/roster/captains/baggins.png",
  sonii: "/assets/roster/captains/sonii.png",
  rakin: "/assets/roster/captains/rakin.png",
  wakayashi: "/assets/roster/captains/wakayashi.png",
  stoopzz: "/assets/roster/captains/stoopzz.png",
};

export const DRAFT_ROSTERS: Record<string, readonly string[]> = {
  tixinha: [
    "Tixinhadois",
    "OuluH",
    "ItsMeMack",
    "agnesmmorpg",
    "jhoolna",
    "Mano_Imp",
    "ZeusGhostz",
    "DeathweaverFT",
    "gathano",
    "NecroNixia",
  ],
  baggins: [
    "BagginsTV",
    "SocietyOfGamin",
    "aselon_eu",
    "Drunge_",
    "Entenburg",
    "Asleyia",
    "Cabolo",
    "Alvaena",
    "tamae_",
    "Hormain",
  ],
  sonii: [
    "SONII",
    "KanonXO",
    "SOLIDFPS",
    "jenny",
    "laufielol",
    "iReviK",
    "Narelio",
    "Hexella",
    "Moshi",
    "ARROWIi",
  ],
  rakin: [
    "Rakin",
    "silence",
    "CAHOS_GAMING",
    "Trollzinha",
    "AfricaAlbion",
    "zPedra",
    "SerllinoGG",
    "SerllinoGG",
    "MainQuestt",
    "MochiiYuki",
  ],
  wakayashi: [
    "Wakayashi",
    "youmadsin",
    "CAHOS_GAMING",
    "Evangelion0",
    "PvE_Zone",
    "Smayro",
    "Yuli",
    "Lipej",
    "AionJanis",
    "Bourrinator",
  ],
  stoopzz: [
    "Stoopzz",
    "Suntokki",
    "wolves",
    "Johnpal",
    "Duky",
    "ArminTF",
    "Vert",
    "XenosysVex",
    "mattshew",
    "DankRNG",
  ],
};
